<template>
  <v-data-table
    :items="problems"
    :headers="headerType(type)"
    :options.sync="options"
    :footer-props="{
      'items-per-page-options': [10, 20, 30, 40, 50, -1]
    }"
    class="elevation-1"
    dense
  >
    <template v-slot:top>
      <v-row>
        <v-col
          class="col-lg-10 col-md-9 col-sm-9"
        />
        <v-spacer></v-spacer>
        <v-col
          v-if="type === 'assyst' && (userHasPermission('edit_software'))"
          class="mb-2"
        >
          <assyst-problem-dialog
            ref="softDialog"
          />
        </v-col>
        <v-col
          v-else-if="type === 'ipaas' && (userHasPermission('edit_software'))"
          class="mb-2"
        >
          <ipaas-problem-dialog
            ref="ipaasDialog"
          />
        </v-col>
        <v-col
          v-else-if="type === 'itom' && (userHasPermission('edit_software'))"
          class="mb-2"
        >
          <itom-software-dialog
            ref="itomDialog"
          />
        </v-col>
      </v-row>
    </template>
    <template
      v-slot:item.occurs_from="{ item }"
    >
      <router-link
        v-if="type === 'assyst'"
        :to="`/software/assyst/${item.occurs_from}`"
        class="text-decoration-none"
      >
        {{ getAssystSoftware(item.occurs_from).assyst_version }}
      </router-link>

      <router-link
        v-if="type === 'ipaas'"
        :to="`/software/ipaas/${item.occurs_from}`"
        class="text-decoration-none"
      >
        {{ getIpaasSoftware(item.occurs_from).ipaas_version }}
      </router-link>
    </template>

    <template
      v-slot:item.fixed_in="{ item }"
    >
      <router-link
        v-if="type === 'assyst' && item.fixed_in > 0"
        :to="`/software/assyst/${item.fixed_in}`"
        class="text-decoration-none"
      >
        {{ getAssystSoftware(item.fixed_in).assyst_version }}
      </router-link>

      <router-link
        v-if="type === 'ipaas' && item.fixed_in > 0"
        :to="`/software/ipaas/${item.fixed_in}`"
        class="text-decoration-none"
      >
        {{ getIpaasSoftware(item.fixed_in).ipaas_version }}
      </router-link>
    </template>

    <template v-slot:item.fixed="{ value }">
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>

    <template v-slot:item.workaround_available="{ value }">
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>

    <template v-slot:item.workaround_in_script="{ value }">
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>

    <template
      v-slot:item.actions="{ item }"
    >
      <v-icon
        v-if="(userHasPermission('edit_software'))"
        small
        class="mr-2"
        @click="editVersion(item)"
      >
        mdi-pencil
      </v-icon>
    </template>
  </v-data-table>
</template>
<script>
  import { get } from 'vuex-pathify'
  export default {
    name: 'ProblemsTable',
    props: {
      problems: Array,
      type: String,
    },
    data () {
      return {
        assyst_headers: [
          { value: 'problem_ref', text: 'Problem', width: '20%'},
          { value: 'affected_app', text: 'Affected App'},
          { value: 'occurs_from', text: 'Occurs From'},
          { value: 'fixed', text: 'Fixed'},
          { value: 'fixed_in', text: 'Fixed In'},
          { value: 'workaround_available', text: 'Workaround Available'},
          { value: 'workaround_in_script', text: 'Workaround In Script'},
        ],
        ipaas_headers: [
          { value: 'ipaas_problem_ref', text: 'Problem', width: '20%'},
          { value: 'occurs_from', text: 'Occurs From'},
          { value: 'fixed', text: 'Fixed'},
          { value: 'fixed_in', text: 'Fixed In'},
          { value: 'workaround_available', text: 'Workaround Available'},
          { value: 'workaround_in_script', text: 'Workaround In Script'},
        ],
        itom_headers: [
          { value: 'itom_problem_ref', text: 'Problem', width: '20%'},
          { value: 'occurs_from', text: 'Occurs From'},
          { value: 'fixed', text: 'Fixed'},
          { value: 'fixed_in', text: 'Fixed In'},
          { value: 'workaround_available', text: 'Workaround Available'},
          { value: 'workaround_in_script', text: 'Workaround In Script'},
        ],
        options: {
          itemsPerPage: -1,
          sortBy: ['problem_id', 'ipaas_problem_id', 'itom_problem_id'],
          sortDesc: [false, false, false],
        },
      }
    },
    computed: {
      ...get('user', [
        'user',
      ]),
      assyst_software () {
        return this.$store.getters['software/assyst']        
      },
      ipaas_software () {
        return this.$store.getters['software/ipaas']        
      },
      itom_software () {
        return this.$store.getters['software/itom']        
      },
    },
    mounted() {
      if (this.userHasPermission('edit_software')) {
        this.assyst_headers.push({ value: 'actions', text: 'Actions', sortable: false })
        this.ipaas_headers.push({ value: 'actions', text: 'Actions', sortable: false })
        this.itom_headers.push({ value: 'actions', text: 'Actions', sortable: false })
      }
    },
    methods: {
      userHasPermission: function (perm) {
        let perms = this.user.permissions.map(a => a.name)
        return perms.includes(perm)
      },
      displayIcon: function (item) {
        if (item === 'y') {
          return 'mdi-check'
        } else {
          return 'mdi-close'
        }
      },
      iconColour: function (item) {
        if (item === 'y') {
          return 'success'
        } else {
          return 'error'
        }
      },
      getAssystSoftware: function (software_id) {
        let version = this.assyst_software.find(element => element.assyst_software_id === software_id)
        return version
      },
      getIpaasSoftware: function (software_id) {
        let version = this.ipaas_software.find(element => element.ipaas_software_id === software_id)
        return version
      },
      getItomSoftware: function (software_id) {
        let version = this.itom_software.find(element => element.itom_software_id === software_id)
        return version
      },
      editVersion: function (item) {
        if (this.type === 'assyst') {
          this.$refs.softDialog.editVersion(item)
        } else if (this.type === 'ipaas') {
          this.$refs.ipaasDialog.editVersion(item)
        } else if (this.type === 'itom') {
          this.$refs.itomDialog.editVersion(item)
        }
      },
      contractCount: function (contracts) {
        return contracts.filter(element => element.status !== 'DR' && element.status !== 'Decommissioned' && element.deleted === 'n').length
      },
      headerType: function (type) {
        switch (type) {
          case 'assyst':
            return this.assyst_headers
          case 'ipaas':
            return this.ipaas_headers
          case 'itom':
            return this.itom_headers
          default:
            break;
        }
      }
    }
  }
</script>